module.exports = "./assets/assets/2.评标活动组织.0b4ef104.docx";